import { Flex, Spin } from "antd";
import React from "react";

interface LoadingProps {
  size?: string;
  color?: string;
}

export const Loading: React.FC<LoadingProps> = () => {
  return <Flex className="min-h-[55vh] justify-center max-w-full items-center"><Spin size="large"></Spin></Flex>;
};
